import { IS_DEV, IS_PROD, IS_STG, IS_STG2 } from 'app/common/constants'

export type SpecialLecture = {
	title: string
	description: string
	videoName: string
	playTime: string
	materialName: string
	krMaterialName: string
}

// 특강 자료 https://drive.google.com/drive/folders/19_yJLVD07T5K1tu-9UaYDUYlQ_m5CIEy

export const baseVideoURL = IS_DEV
	? 'https://bridge.knowre-dev.com/video/'
	: IS_STG
		? 'https://stg.briiidgeproject.com/video/'
		: IS_STG2
			? 'https://stg2.briiidgeproject.com/video/'
			: IS_PROD
				? 'https://briiidgeproject.com/video/'
				: 'https://bridge.knowre-dev.com/video/' // local

export const baseMaterialURL = '/material/'

export const StudentVideoList: SpecialLecture[] = [
	{
		title: '갓생사는 7가지 방법',
		description:
			'왜 공부를 해야하는지, 공부를 하면 무엇이 좋은 것인지 알려주는 강의입니다.',
		videoName: 'student_lecture_001.mp4',
		playTime: '51:41',
		materialName: 's1.pdf',
		krMaterialName: '1강 갓생 사는 방법 7가지.pdf',
	},
	{
		title: '공부를 잘하고 싶으면 당연히 많이 해야 잘한다.',
		description:
			'공부를 잘하는 특별한 방법은 없다. 내가 가고 싶은 대학 몇시간 공부해야 할지 알려주는 강의입니다.',
		videoName: 'student_lecture_002.mp4',
		playTime: '13:46',
		materialName: 's2.pdf',
		krMaterialName:
			'2강 공부를 잘하고 싶으면 당연히 많이 해야 잘한다.pdf',
	},
	{
		title: '학원은 원래 다니는 것이 아니다.',
		description:
			'학원은 원래 안 다니는 것이다. 학원 감별법을 알려주는 강의입니다.',
		videoName: 'student_lecture_003.mp4',
		playTime: '53:40',
		materialName: 's3.pdf',
		krMaterialName:
			'3강 학원은 원래 다니는 것이 아니다.pdf',
	},
	{
		title: '시험공부는 평상시에 하는 것이다.',
		description:
			'내신 1등하는 방법은 아주 단순하다. 학원 다니지 않아도 1등하는 방법을 알려주는 강의입니다. ',
		videoName: 'student_lecture_004.mp4',
		playTime: '41:18',
		materialName: 's4.pdf',
		krMaterialName:
			'4강 시험 공부는 평상시에 하는 것이다.pdf',
	},
	{
		title: '공부 방법도  MBTI에 맞춰야 잘할 수 있다.',
		description:
			'내 성격에 맞게 공부해야 힘든 공부도 조금 덜 힘들 수 있다. 내 성격에 맞는 공부 방법을 알려주는 강의입니다.',
		videoName: 'student_lecture_005.mp4',
		playTime: '45:29',
		materialName: 's5.pdf',
		krMaterialName:
			'5강 공부방법도 MBTI에 맞춰야 잘할 수 있다.pdf',
	},
	{
		title: '학교 수업 직전/ 직후 3분은 게임케쉬다.',
		description:
			'수업 전후 3분은 시험기간 공부 3시간의 효과가 있다는 것을 알려주는 강의입니다.',
		videoName: 'student_lecture_006.mp4',
		playTime: '14:02',
		materialName: 's6.pdf',
		krMaterialName:
			'6강 수업 직전, 직후 3분은 게임 캐시다.pdf',
	},
]

export const ParentVideoList: SpecialLecture[] = [
	{
		title: '쉽고 빠른길은 어디에도 없습니다. 많이 시키십시오.',
		description: '광고에 끌려 다니지 마시고, 제대로 내 아이를 공부시키는 방법을 알려주는 강의입니다.',
		videoName: 'parent_lecture_001.mp4',
		playTime: '15:51',
		materialName: 'p1.pdf',
		krMaterialName: '1강_특별한 방법은 없습니다.그냥 많이 시키십시오.pdf',
	},
	{
		title: '공부 안하는 아이 공부 시키는 방법',
		description: '공부 시작이 어려운 아이를 어떻게 해야 공부를 하게 만드는지 알려주는 강의입니다.',
		videoName: 'parent_lecture_002.mp4',
		playTime: '01:08:22',
		materialName: 'p2.pdf',
		krMaterialName: '2강_공부 안하는 아이 공부시키는 방법.pdf',
	},
	{
		title: '1시간 만에 끝내는 대학 입시',
		description: '냉정한 현실 입시를 아셔야 아이를 잘 지도할 수 있습니다. 지금의 대입을 현실적으로 알려주는 강의입니다.',
		videoName: 'parent_lecture_003.mp4',
		playTime: '47:34',
		materialName: 'p3.pdf',
		krMaterialName: '3강_1시간 만에 끝내는 대학 입시.pdf',
	},
	{
		title: 'EBS만 제대로 해도 SKY는 충분합니다.',
		description: '대치동과 같은 공부 효율을 낼 수 있는 EBS커리큘럼을 알려주는 강의입니다.',
		videoName: 'parent_lecture_004.mp4',
		playTime: '30:11',
		materialName: 'p4.pdf',
		krMaterialName: '4강_EBS만 제대로 해도 SKY진학 충분합니다.pdf',
	},
	{
		title: '이런 학원 절대 No! 내신학원 선택하는 방법',
		description: '고등학교에 들어가면 성적이 폭락하는 아이로 만들지 않기위한 제대로된 학원 선택 방법입니다.',
		videoName: 'parent_lecture_005.mp4',
		playTime: '05:08',
		materialName: 'p5.pdf',
		krMaterialName: '5강_내신학원의 필요성.pdf',
	},
	{
		title: '내신 시험 만점을 만드는 부모의 관리 방법',
		description: '학원에 보내도 성적이 오르지 않는 아이, 집에서 제대로 공부시키는 방법을 알려주는 강의입니다.',
		videoName: 'parent_lecture_006.mp4',
		playTime: '45:35',
		materialName: 'p6.pdf',
		krMaterialName: '6강_내신 시험 만점을 만드는 부모의 관리 방법.pdf',
	},
]
